import { getSessionData } from "../utilfunctions/utilFunctions";

const XPORTFOLIO_API =
  process.env.REACT_APP_XPORTFOLIO_API_URL ||
  "/portal/www/xPortfolio/api.php";

function xPortfolioUrl(resource) {
  const [name, ...query] = resource.split("&");
  return `${XPORTFOLIO_API}?resource=${encodeURIComponent(name)}${query.length ? `&${query.join("&")}` : ""}`;
}

function getPortalUserId() {
  try {
    const storedUser = JSON.parse(sessionStorage.getItem("user") || "null");
    return storedUser?.payload?.body?.User?.id || "";
  } catch {
    return "";
  }
}

function xPortfolioHeaders(body, extraHeaders = {}) {
  const session = getSessionData();
  const isFormData = typeof FormData !== "undefined" && body instanceof FormData;
  return {
    Accept: "application/json",
    "X-Paiy-Auth-User": session.authUser || "",
    "X-Paiy-User-Id": getPortalUserId(),
    "X-Paiy-Portal-Origin": window.location.origin,
    "X-Paiy-Session-Id": session.sessionID || "",
    "X-Paiy-View-Id": session._viewid || "",
    "X-Paiy-Device-Token": session._devicetoken || "",
    ...(body && !isFormData ? { "Content-Type": "application/json" } : {}),
    ...extraHeaders,
  };
}

export async function xPortfolioRequest(resource, options = {}) {
  const response = await fetch(
    xPortfolioUrl(resource),
    {
      credentials: "include",
      ...options,
      headers: xPortfolioHeaders(options.body, options.headers),
    }
  );

  const rawBody = await response.text();
  let result;
  try {
    result = JSON.parse(rawBody);
  } catch {
    throw new Error(`xPortfolio returned an invalid response (HTTP ${response.status}).`);
  }

  if (!response.ok) {
    throw new Error(result.detail || result.error || "xPortfolio request failed.");
  }
  return result;
}

async function xPortfolioFileRequest(resource, options = {}) {
  const response = await fetch(xPortfolioUrl(resource), {
    credentials: "include",
    ...options,
    headers: xPortfolioHeaders(options.body, options.headers),
  });
  if (!response.ok) {
    let message = "The document request failed.";
    try { const result = await response.json(); message = result.detail || result.error || message; } catch { /* binary response */ }
    throw new Error(message);
  }
  return response;
}

export const getXPortfolioHealth = () => xPortfolioRequest("health", { cache: "no-store" });
export const getXPortfolioState = () => xPortfolioRequest("state", { cache: "no-store" });
export const createXPortfolioInvestment = (payload) => xPortfolioRequest("investment", {
  method: "POST",
  body: JSON.stringify(payload),
});
export const createXPortfolioDistribution = (payload) => xPortfolioRequest("distribution", {
  method: "POST",
  body: JSON.stringify(payload),
});
export const createXPortfolioApplication = (payload) => xPortfolioRequest("application", {
  method: "POST",
  body: JSON.stringify(payload),
});
export const createXPortfolioAnnouncement = (payload) => xPortfolioRequest("announcement", {
  method: "POST",
  body: JSON.stringify(payload),
});
export const reorderXPortfolioAnnouncements = (announcementIds) => xPortfolioRequest("announcement-order", {
  method: "POST",
  body: JSON.stringify({ announcementIds }),
});
export const createXPortfolioUser = (payload) => xPortfolioRequest("user", { method: "POST", body: JSON.stringify(payload) });
export const updateXPortfolioUser = (payload) => xPortfolioRequest("user", { method: "PATCH", body: JSON.stringify(payload) });
export const createXPortfolioFund = (payload) => xPortfolioRequest("fund", { method: "POST", body: JSON.stringify(payload) });
export const createXPortfolioFolder = (payload) => xPortfolioRequest("document-folder", { method: "POST", body: JSON.stringify(payload) });
export const updateXPortfolioFolder = (payload) => xPortfolioRequest("document-folder", { method: "PATCH", body: JSON.stringify(payload) });
export const deleteXPortfolioFolder = (id) => xPortfolioRequest("document-folder", { method: "DELETE", body: JSON.stringify({ id }) });
export const uploadXPortfolioDocuments = (formData) => xPortfolioRequest("documents", { method: "POST", body: formData });
export const updateXPortfolioDocument = (payload) => xPortfolioRequest("documents", { method: "PATCH", body: JSON.stringify(payload) });
export const deleteXPortfolioDocuments = (ids) => xPortfolioRequest("documents", { method: "DELETE", body: JSON.stringify({ action: "delete", ids }) });
export const moveXPortfolioDocuments = (ids, destination) => xPortfolioRequest("documents", { method: "PUT", body: JSON.stringify({ action: "move", ids, destination }) });
export const getXPortfolioDocumentHistory = (id) => xPortfolioRequest(`documents&operation=history&id=${encodeURIComponent(id)}`, { cache: "no-store" });
export const replaceXPortfolioDocument = (id, file) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("document", file);
  return xPortfolioRequest("document-version", { method: "POST", body: formData });
};
export const getXPortfolioDocumentFile = async (id, mode = "preview") => {
  const parameter = mode === "download" ? "download" : "preview";
  const response = await xPortfolioFileRequest(`documents&${parameter}=${encodeURIComponent(id)}`, { cache: "no-store" });
  return { blob: await response.blob(), contentType: response.headers.get("Content-Type") || "application/octet-stream" };
};
export const updateXPortfolioRole = (payload) => xPortfolioRequest("access-role", { method: "PATCH", body: JSON.stringify(payload) });
export const createXPortfolioRole = (payload) => xPortfolioRequest("access-role", { method: "POST", body: JSON.stringify(payload) });
export const createXPortfolioDelegation = (payload) => xPortfolioRequest("authority-delegation", { method: "POST", body: JSON.stringify(payload) });
export const revokeXPortfolioDelegation = (id) => xPortfolioRequest("authority-delegation", { method: "DELETE", body: JSON.stringify({ id }) });
